import React from 'react'
import './Companies.css'

function Companies() {
  return (
    <div className="companies-section">
        <div className="container">
            <div className="companies-content">
                <h2>Our Trusted Identity in Secure Services</h2>
                <div className="companies-logo">
                    <img src="./images/access.svg" alt="" />
                    <img src="./images/gt.svg" alt="" />
                    <img src="./images/ecobank.svg" alt="" />
                    <img src="./images/stanbic.svg" alt="" />
                    <img src="./images/fbn.svg" alt="" />
                    <img src="./images/sterling.svg" alt="" />
                    <img src="./images/fcmb.svg" alt="" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Companies
